import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const MOTRICITY_INDEX_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.MOTRICITY,
  title: 'Motricity Index (MI)',
  scoreConfig: {
    scoreKey: 'totale_generale',
    scoreFields: ['presa', 'gomito', 'spalla', 'caviglia', 'ginocchio', 'anca'],
  },
  sections: [
    {
      name: 'motricity_index',
      label: 'Motricity Index',
      fields: [
        // --- ARTO SUPERIORE ---
        {
          key: 'presa',
          label: 'Presa (pinch grip)',
          type: 'number',
          min: 0,
          max: 33,
          step: 1,
          maxScore: 33,
          valueDescriptions: {
            '0': 'Nessuna contrazione.',
            '11': 'Tenta, ma nessuna presa efficace.',
            '19': 'Presa parziale.',
            '22': 'Buona presa.',
            '33': 'Presa normale.',
          },
          description: 'Valuta la capacità di effettuare la presa a pinza.',
        },
        {
          key: 'gomito',
          label: 'Flessione del gomito',
          type: 'number',
          min: 0,
          max: 25,
          step: 1,
          maxScore: 25,
          valueDescriptions: {
            '0': 'Nessuna contrazione.',
            '9': 'Movimento incompleto contro la gravità.',
            '14': 'Movimento completo contro la gravità.',
            '18': 'Movimento con resistenza minima.',
            '25': 'Forza normale.',
          },
          description:
            'Valuta la flessione del gomito dell’arto superiore colpito.',
        },
        {
          key: 'spalla',
          label: 'Abduzione della spalla',
          type: 'number',
          min: 0,
          max: 25,
          step: 1,
          maxScore: 25,
          valueDescriptions: {
            '0': 'Nessuna contrazione.',
            '9': 'Movimento incompleto.',
            '14': 'Movimento completo contro la gravità.',
            '18': 'Movimento con moderata resistenza.',
            '25': 'Forza normale.',
          },
          description:
            'Valuta l’abduzione della spalla dell’arto superiore colpito.',
        },
        // --- ARTO INFERIORE ---
        {
          key: 'caviglia',
          label: 'Dorsiflessione della caviglia',
          type: 'number',
          min: 0,
          max: 25,
          step: 1,
          maxScore: 25,
          valueDescriptions: {
            '0': 'Nessuna contrazione.',
            '9': 'Movimento incompleto.',
            '14': 'Movimento completo contro gravità.',
            '18': 'Movimento con resistenza moderata.',
            '25': 'Forza normale.',
          },
          description: 'Valuta la dorsiflessione della caviglia.',
        },
        {
          key: 'ginocchio',
          label: 'Estensione del ginocchio',
          type: 'number',
          min: 0,
          max: 25,
          step: 1,
          maxScore: 25,
          valueDescriptions: {
            '0': 'Nessun movimento.',
            '9': 'Movimento incompleto.',
            '14': 'Movimento completo.',
            '18': 'Resistenza moderata.',
            '25': 'Forza normale.',
          },
          description: 'Valuta la forza estensoria del ginocchio.',
        },
        {
          key: 'anca',
          label: "Flessione dell'anca",
          type: 'number',
          min: 0,
          max: 25,
          step: 1,
          maxScore: 25,
          valueDescriptions: {
            '0': 'Nessuna contrazione.',
            '9': 'Movimento incompleto.',
            '14': 'Movimento completo.',
            '18': 'Movimento con resistenza.',
            '25': 'Forza normale.',
          },
          description: 'Valuta la flessione dell’anca.',
        },
      ],
    },
  ],
  computedFields: [
    // --- DOMINI ---
    {
      key: 'mi_superiore',
      label: 'MI – Arto superiore',
      type: 'number',
      calculation: 'SUM([presa, gomito, spalla])',
      maxScore: 100,
    },
    {
      key: 'mi_inferiore',
      label: 'MI – Arto inferiore',
      type: 'number',
      calculation: 'SUM([caviglia, ginocchio, anca])',
      maxScore: 100,
    },
    // --- TOTALE ---
    {
      key: 'totale_generale',
      label: 'Totale generale (0–200)',
      type: 'number',
      calculation: 'SUM([mi_superiore, mi_inferiore])',
      maxScore: 200,
    },
    // --- INTERPRETAZIONE ---
    {
      key: 'interpretazione',
      label: 'Interpretazione clinica',
      type: 'text',
      calculation: `
        IF(totale_generale >= 160, "Forza globale buona",
          IF(totale_generale >= 100, "Forza moderata",
            IF(totale_generale >= 40, "Forza severamente ridotta",
              "Forza gravemente compromessa"
            )
          )
        )
      `,
      maxScore: 0,
    },
  ],
};
